var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 11.5625C19.1875 8.25 15.8125 6 12 6C8.15625 6 4.78125 8.25 3.09375 11.5625C3.03125 11.6875 3 11.8438 3 12C3 12.1875 3.03125 12.3438 3.09375 12.4688C4.78125 15.7812 8.15625 18 12 18C15.8125 18 19.1875 15.7812 20.875 12.4688C20.9375 12.3438 20.9688 12.1875 20.9688 12.0312C20.9688 11.8438 20.9375 11.6875 20.875 11.5625ZM12 16.5C9.5 16.5 7.5 14.5 7.5 12C7.5 9.53125 9.5 7.5 12 7.5C14.4688 7.5 16.5 9.53125 16.5 12V12.0312C16.5 14.5 14.4688 16.5312 12 16.5312V16.5ZM12 9C11.7188 9.03125 11.4375 9.0625 11.1875 9.125C11.375 9.375 11.4688 9.6875 11.4688 10.0312C11.4688 10.8438 10.8125 11.5 10 11.5C9.65625 11.5 9.34375 11.4062 9.09375 11.2188C9.03125 11.4688 9 11.75 9 12C9 13.6562 10.3438 15 12 15C13.6562 15 15 13.6562 15 12C15 10.3438 13.6562 9.03125 12 9.03125V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.98ac239c31fddeb0beae96ad01b2b66c.svg";
export { ForwardRef as ReactComponent };